import React, { useState } from 'react'
import PropTypes from 'prop-types'
import c from 'classnames'
import { useSelector } from 'react-redux'
import Exs from '../icons/exs'
import { selectClaimProofLossImagesByDevice } from '../../selectors/claim'

export function Evidence({ className, onClose, deviceId }) {
  const images = useSelector((state) => selectClaimProofLossImagesByDevice(state, deviceId))
  const [currentImage, setCurrentImage] = useState(images[0])
  const onSelectThumb = (id) => {
    const found = images.find((img) => img.id === id)
    setCurrentImage(found)
  }
  return (
    <div className={c('evidence', className)}>
      <div className="modal show" style={{ display: 'block' }}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <div className="evidence__content">
                <button onClick={onClose} type="button" className="evidence__close"><Exs /></button>
                <div className="evidence__heading">
                  <h2 className="evidence__title">Upload Evidence</h2>
                  <div className="evidence__desc">View uploaded media evidence for the claim</div>
                </div>
                <div>
                  <div className="image">
                    {currentImage.processing_status ? <div className="soft">Image is proccessing</div> : null}
                    <div className="image__sidebar">
                      {images.map((img) => (
                        <button onClick={() => onSelectThumb(img.id)} key={img.id} type="button" className="image__thumb">
                          <img alt="" src={img.public_url} />
                        </button>
                      ))}
                    </div>
                    <div className="image__view">
                      {currentImage.processing_status ? null : <img src={currentImage.public_url} alt="" />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </div>
  )
}
export default Evidence

Evidence.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  deviceId: PropTypes.number.isRequired,
}
Evidence.defaultProps = {
  className: '',
  onClose: () => {},
}
